export default "__VITE_ASSET__CMGzDAsP__"